module.exports = __webpack_public_path__ + "static/media/web_Bianca-27-Edit.10892c3e.jpg";